import type { Printability3dService } from '../services/printability3dService';
import type { Printability2dService } from '../services/printability2dService';
import type { PartUploadService } from '../services/partUploadService';
import type { MaterialsService } from '../services/materialsService';
import type { CastorMaterialsService } from '../services/castorMaterialsService';
import type { CastorProjectsService } from '../services/castorProjectsService';

export interface PrintabilityServices {
  printability3dService: Printability3dService;
  printability2dService: Printability2dService;
  partUploadService: PartUploadService;
  /** Senvol material catalog — resolves a suggested family into concrete materials. */
  materialsService: MaterialsService;
  castorMaterialsService: CastorMaterialsService;
  castorProjectsService: CastorProjectsService;
}

let _services: PrintabilityServices | null = null;

export function initPrintabilityServices(s: PrintabilityServices): void {
  _services = s;
}

export function getPrintabilityServices(): PrintabilityServices {
  if (!_services)
    throw new Error(
      'Printability services not initialized. Call initPrintabilityServices() at app startup.',
    );
  return _services;
}
